import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'partners';
export const partnersActions = makeActions(MODEL_NAME);

export const getAllPartners = partnersActions.getAll;
export const editPartners = partnersActions.edit;
export const createPartners = partnersActions.create;
export const getByIdPartners = partnersActions.getDataById;
